import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';
import {
	GET_CENTROS,
	GET_CENTROS_BY_PAGINATOR,
	UPDATE_CENTER,
	GET_ERRORS,
	CREATE_CENTER,
	DELETE_CENTER,
	REFACTOR_CENTER

} from './types';

const URL_GETCENTERS              = process.env.REACT_APP_API_URL + services.getCenters;
const URL_GETCENTERS_BY_PAGINATOR = process.env.REACT_APP_API_URL + services.getCentersByPaginator;
const URL_ADDCENTER               = process.env.REACT_APP_API_URL + services.addCenter;
const URL_PATCH_CENTER            = process.env.REACT_APP_API_URL + services.updateCenter;
const URL_DELETE_CENTER           = process.env.REACT_APP_API_URL + services.deleteCenter;
const URL_REFACT_INNER            = process.env.REACT_APP_API_URL + services.refactInnerBranch;


export const getCenters = (skip, limit) => dispatch => {

	const filterURL = URL_GETCENTERS
	const data = {
		'is_active': true,
	}

	if (skip)
		data['page'] = skip
	if (limit)
		data['limit'] = limit
	axios
		.post(filterURL, data)
		.then(res => {
			dispatch({
				type: GET_CENTROS,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};

export const getCentersByPaginator = (page = 1, limit = 20) => dispatch => {

	const filterURL = URL_GETCENTERS_BY_PAGINATOR
	const params    = {
		is_active:  1,
		page:       page,
		limit:      limit,
		sort:       'ASC',
	    field_sort: 'nombre',
	}
	axios
		.post(filterURL, params)
		.then(res => {
			dispatch({
				type:    GET_CENTROS_BY_PAGINATOR,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};

export const updateCenter = (_id,
	nombre,
	clave,
	usoHorario,
	calle,
	numeroExterior,
	numeroInterior,
	colonia,
	codigoPostal,
	municipio,
	estado,
	latitude,
	longitude) => dispatch => {

		const data = {
			id: _id,
			nombre: nombre,
			clave: clave,
			usoHorario: usoHorario,
			calle: calle,
			numeroExterior: numeroExterior,
			numeroInterior: numeroInterior,
			colonia: colonia,
			codigoPostal: codigoPostal,
			municipio: municipio,
			estado: estado,
			latitude: latitude,
			longitude: longitude
		}
		const URL = URL_PATCH_CENTER
		axios
			.post(URL, data)
			.then(res => {
				dispatch({
					type: UPDATE_CENTER,
					payload: res.result
				})

			})
			.catch(error => {
				dispatch({
					type: GET_ERRORS,
					payload: getErrorMessage(error)
				})
			});
	}

export const addCenter = (
	nombre,
	clave,
	usoHorario,
	calle,
	numeroExterior,
	numeroInterior,
	colonia,
	codigoPostal,
	municipio,
	estado,
	latitude,
	longitude
) => dispatch => {
	const data = {
		nombre: nombre,
		clave: clave,
		usoHorario: usoHorario,
		calle: calle,
		numeroExterior: numeroExterior,
		numeroInterior: numeroInterior,
		colonia: colonia,
		codigoPostal: codigoPostal,
		municipio: municipio,
		estado: estado,
		latitude: latitude,
		longitude: longitude

	}
	axios
		.post(URL_ADDCENTER, data)
		.then(res => {
			dispatch({
				type: CREATE_CENTER,
				payload: res.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const deleteCenter = (id) => dispatch => {
	const URL = URL_DELETE_CENTER + id
	axios
		.get(URL)
		.then(res => {
			dispatch({
				type: DELETE_CENTER,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const refactInnerBrachId = (old, new_clave) => dispatch => {
	const URL = URL_REFACT_INNER;
	const data = {
		'old_innerBranchId': old,
		'new_clave': new_clave
	}
	axios
		.post(URL, data)
		.then(res => {
			dispatch({
				type: REFACTOR_CENTER,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}
